import React from 'react';
import Sky from 'react-sky';
import angryEmoji from '../../static/images/angryEmoji.png';
import ultraHappyEmoji from '../../static/images/ultraHappy.png';

class SkyBg extends React.Component {

    state ={
        emotionPicture: {
            angry: angryEmoji,
            happy: ultraHappyEmoji
        }
    }
    
    render(){
        const {emotionProbability} = this.props;
        // return(
        //     <Sky 
        //         images={{
        //         /* FORMAT AS FOLLOWS */
        //         0: ,  /* You can pass as much images as you want */
        //         }}
        //         how={130} /* You have to pass a number so Sky will render that amount of images chosen randomly from the object you passed in the previous step */
        //         time={40} /* time of the animation. Dfaults at 20s */
        //         size={'100px'} /* size of the rendered images. Defaults at 150px */
        //         background={'palettedvioletred'} /* color of background. Defaults to none */
        //     />


            
        // )

        if (emotionProbability >= 0.8 && emotionProbability < 1000) {
            return (
                <Sky 
                images={{
                /* FORMAT AS FOLLOWS */
                0: ultraHappyEmoji,  /* You can pass as much images as you want */
                }}
                how={130} /* You have to pass a number so Sky will render that amount of images chosen randomly from the object you passed in the previous step */
                time={40} /* time of the animation. Dfaults at 20s */
                size={'100px'} /* size of the rendered images. Defaults at 150px */
                background={'palettedvioletred'} /* color of background. Defaults to none */
            />
            )
        } else if (emotionProbability < 0.2){
            return (
                <Sky 
                images={{
                /* FORMAT AS FOLLOWS */
                0: angryEmoji,  /* You can pass as much images as you want */
                }}
                how={130} /* You have to pass a number so Sky will render that amount of images chosen randomly from the object you passed in the previous step */
                time={40} /* time of the animation. Dfaults at 20s */
                size={'100px'} /* size of the rendered images. Defaults at 150px */
                background={'palettedvioletred'} /* color of background. Defaults to none */
            />
            )
        } else {
            return null;
        }
        
    }
}

export default SkyBg;


// WEBPACK FOOTER //
// ./src/components/Sky/SkyBg.js